import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ParentSignup from './pages/ParentSignup';
import ParentLogin from './pages/ParentLogin';
import ChildLogin from './pages/ChildLogin';
import ParentDashboard from './pages/ParentDashboard';
import ParentSettings from './pages/ParentSettings';
import ParentSettlements from './pages/ParentSettlements';
import WalletManagement from './pages/WalletManagement';
import ChildDashboard from './pages/ChildDashboard';
import ChildPoints from './pages/ChildPoints';
import ChildRecords from './pages/ChildRecords';
import ChildBadges from './pages/ChildBadges';
import ChildSettings from './pages/ChildSettings';
import MissionManagement from './pages/MissionManagement';
import ApprovalManagement from './pages/ApprovalManagement';
import ChildrenManagement from './pages/ChildrenManagement';
import Reports from './pages/parent/Reports';
import RewardRequests from './pages/RewardRequests';
import About from './pages/About';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Auth pages with auth-container */}
        <Route path="/parent/signup" element={<div className="auth-container"><ParentSignup /></div>} />
        <Route path="/parent/login" element={<div className="auth-container"><ParentLogin /></div>} />
        <Route path="/child/login" element={<div className="auth-container"><ChildLogin /></div>} />

        {/* All other pages with container */}
        <Route path="/" element={<div className="container"><HomePage /></div>} />
        <Route path="/about" element={<div className="container"><About /></div>} />
        <Route path="/terms" element={<div className="container"><Terms /></div>} />
        <Route path="/privacy" element={<div className="container"><PrivacyPolicy /></div>} />
        <Route path="/parent/dashboard" element={<div className="container"><ParentDashboard /></div>} />
        <Route path="/parent/settings" element={<div className="container"><ParentSettings /></div>} />
        <Route path="/parent/settlements" element={<div className="container"><ParentSettlements /></div>} />
        <Route path="/parent/wallets" element={<div className="container"><WalletManagement /></div>} />
        <Route path="/parent/missions" element={<div className="container"><MissionManagement /></div>} />
        <Route path="/parent/missions/new" element={<div className="container"><MissionManagement /></div>} />
        <Route path="/parent/approvals" element={<div className="container"><ApprovalManagement /></div>} />
        <Route path="/parent/children" element={<div className="container"><ChildrenManagement /></div>} />
        <Route path="/parent/reports" element={<div className="container"><Reports /></div>} />
        <Route path="/parent/rewards" element={<div className="container"><RewardRequests /></div>} />
        <Route path="/child/dashboard" element={<div className="container"><ChildDashboard /></div>} />
        <Route path="/child/points" element={<div className="container"><ChildPoints /></div>} />
        <Route path="/child/records" element={<div className="container"><ChildRecords /></div>} />
        <Route path="/child/badges" element={<div className="container"><ChildBadges /></div>} />
        <Route path="/child/settings" element={<div className="container"><ChildSettings /></div>} />
      </Routes>

      {/* 쿠키 동의 배너 */}
      <CookieConsent />
    </Router>
  );
}

export default App;